<template>
    <div class="d-flex align-center mx-2">

        <div class="ml-4 flex-grow-1">
            <div class="text-h5 font-weight-light">
                {{employee.name}}
            </div>
        </div>

<!--        <div>-->
<!--            <v-menu-->
<!--                    ref="menu"-->
<!--                    v-model="dateMenu"-->
<!--                    :close-on-content-click="false"-->
<!--                    transition="scale-transition"-->
<!--                    offset-y-->
<!--            >-->
<!--                <template v-slot:activator="{ on, attrs }">-->
<!--                    <v-btn-->
<!--                            color="primary"-->
<!--                            class="mx-2"-->
<!--                            small-->
<!--                            outlined-->
<!--                            v-on="on"-->
<!--                    >-->
<!--                        <v-icon small left>mdi-calendar</v-icon>-->
<!--                        {{ dateTitle }}-->
<!--                    </v-btn>-->
<!--                </template>-->

<!--                <v-card class="lightSurface">-->
<!--                    <div class="d-flex">-->
<!--                        <v-date-picker-->
<!--                                v-if="!resetDtPicker"-->
<!--                                v-model="dates"-->
<!--                                range-->
<!--                                no-title-->
<!--                                scrollable-->
<!--                                :max="maxDate"-->
<!--                                :first-day-of-week="1"-->
<!--                                flat-->
<!--                                color="primary"-->
<!--                        />-->
<!--                        <div class="d-flex flex-column justify-space-around">-->
<!--                            <template v-for="filter in filters">-->
<!--                                <v-btn-->
<!--                                        :key="filter.title"-->
<!--                                        color="primary"-->
<!--                                        text-->
<!--                                        small-->
<!--                                        @click="setDates(filter.cb(filter.title))"-->
<!--                                >-->
<!--                                    {{filter.title}}-->
<!--                                </v-btn>-->
<!--                            </template>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <v-divider></v-divider>-->
<!--                    <v-card-actions class="d-flex justify-end">-->
<!--                        <v-spacer></v-spacer>-->
<!--                        <v-btn-->
<!--                                small-->
<!--                                color="secondary"-->
<!--                                @click="dateMenu = false"-->
<!--                        >-->
<!--                            Done-->
<!--                        </v-btn>-->
<!--                    </v-card-actions>-->
<!--                </v-card>-->

<!--            </v-menu>-->
<!--        </div>-->

        <div>
            <app-toolbar-date-selector :range="this.$store.state.ref.dashboard.selectedRange"></app-toolbar-date-selector>
        </div>

        <v-btn
            v-if="access.leave"
            color="primary"
            small
            outlined
            @click="$store.state.ref.employeeStats.showAddLeaveRecord = true"
            class="mr-2"
        >
            <v-icon small left>mdi-plus</v-icon>
            Add leave record
        </v-btn>

        <v-tooltip left v-if="access.setup">
            <template v-slot:activator="{on}">
                <v-btn
                        color="primary"
                        class="mx-2"
                        small
                        icon
                        v-on="on"
                        @click="gotoEmployeeSettings(employee._id)"
                >
                    <v-icon>mdi-cog</v-icon>
                </v-btn>
            </template>
            Settings
        </v-tooltip>

<!--        <v-btn-->
<!--                icon-->
<!--                color="primary"-->
<!--                class="mx-2"-->
<!--                small-->
<!--        >-->
<!--            <v-icon>mdi-microsoft-excel</v-icon>-->
<!--        </v-btn>-->
        <v-btn
                icon
                color="primary"
                class="mx-2"
                small
                @click="$store.state.ref.employeeStats.showCardsSelection = true"
        >
            <v-icon>mdi-apps</v-icon>
        </v-btn>
    </div>
</template>

<script>
import {
    addDays,
    endOfDay, endOfMonth,
    endOfWeek,
    format, isMonday,
    isSameDay,
    isSameMonth,
    isSameYear,
    startOfDay, startOfMonth,
    startOfWeek,
    subDays, subMonths, subWeeks
} from "date-fns";
import AppEmployeeAdd from "@/components/Employees/AppEmployeeAdd";
import {mapActions, mapGetters} from "vuex";
import AppToolbarDateSelector from "@/components/Shared/AppToolbarDateSelector.vue";

const calFmt = (date) => {
    try {
        return format(date, 'yyyy-MM-dd')
    } catch (e) {
        return null;
    }
}

export default {
    components: {AppToolbarDateSelector},
    props: {
        shown: Boolean,
    },
    data() {
        return {
            resetDtPicker: false,
            dateMenu: false,
            maxDate: (() => {return calFmt(new Date)})(),
            filters: [
                {
                    title: "Today",
                    cb: (title) => {
                        return {
                            title: title,
                            start: startOfDay(new Date()),
                            end: endOfDay(new Date()),
                        }
                    }
                },
                {
                    title: "Yesterday",
                    cb: (title) => {
                        return {
                            title: title,
                            start: startOfDay(subDays(new Date(), 1)),
                            end: endOfDay(subDays(new Date(), 1)),
                        }
                    }
                },
                {
                    title: "This Week",
                    cb: (title) => {
                        let start = new Date()
                        while (!isMonday(start))
                            start = subDays(start, 1)
                        return {
                            title,
                            start: start,
                            end: new Date(),
                        }
                    }
                },
                {
                    title: "Last Week",
                    cb: (title) => {
                        let start = subWeeks(new Date(), 1)
                        while (!isMonday(start))
                            start = subDays(start, 1)
                        return {
                            title,
                            start: start,
                            end: addDays(start, 6)
                        }
                    }
                },
                {
                    title: "This Month",
                    cb: (title) => {
                        return {
                            title,
                            start: startOfMonth(new Date()),
                            end: new Date(),
                        }
                    }
                },
                {
                    title: "Last Month",
                    cb: (title) => {
                        return {
                            title,
                            start: startOfMonth(subMonths(new Date(), 1)),
                            end: endOfMonth(subMonths(new Date(), 1)),
                        }
                    }
                },
            ],
            showAddEmployee: false
        }
    },
    watch: {
        resetDtPicker(val) {
            if (val)
                this.$nextTick(() => {
                    this.resetDtPicker = false
                })
        }

    },
    methods: {
        ...mapActions(['gotoEmployeeSettings', 'gotoDeviceSettings']),
        setDates({start, end, title}) {
            this.range.title = title
            this.range.start = start;
            this.range.end = end;
            this.dateMenu = false
        }
    },
    computed: {
        ...mapGetters(['employeesRef', 'devicesByEmployee', "teamsRef", 'access']),

        team() {
            return this.teamsRef[this.employee.teamId]
        },

        devices() {
            // console.log()
            return this.employeesRef[this.$store.state.ref.employeeStats.selectedEmployee];
        },

        employee() {
            // console.log()
            return this.employeesRef[this.$store.state.ref.employeeStats.selectedEmployee];
        },

        range() {
            return this.$store.state.ref.dashboard.selectedRange
        },
        dateTitle() {
            // TODO Add Here
            // if (this.range.title)
            //     return this.range.title
            if (!isSameYear(this.range.start, this.range.end))
                return `${format(this.range.start,'dd MMM yyyy')} - ${format(this.range.end,'dd MMM yyyy')}`
            if (!isSameMonth(this.range.start, this.range.end))
                return `${format(this.range.start,'dd MMM')} - ${format(this.range.end,'dd MMM yyyy')}`
            if (!isSameDay(this.range.start, this.range.end))
                return `${format(this.range.start,'dd')} - ${format(this.range.end,'dd MMM yyyy')}`
            return format(this.range.end,'dd MMM yyyy')
        },
        dates: {
            get() {
                return isSameDay(this.range.start, this.range.end) ? [calFmt(this.range.start, 'yyyy-MM-dd')] : [calFmt(this.range.start, 'yyyy-MM-dd'), calFmt(this.range.end, 'yyyy-MM-dd')]
            },
            set(dates) {
                if (!dates || !dates.length) {
                    this.range.start = new Date();
                    this.range.end = new Date();
                    return;
                }
                if (dates.length === 1) {
                    this.range.start = new Date(dates[0]);
                    this.range.end = new Date(dates[0]);
                } else {
                    const dt1 = new Date(dates[0]);
                    const dt2 = new Date(dates[1]);
                    this.range.start = dt1 < dt2 ? dt1 : dt2;
                    this.range.end = dt1 < dt2 ? dt2 : dt1;
                }
            }
        }
    },
}
</script>

<style scoped>

</style>